import { useEffect } from "react"
import { useParams } from "react-router-dom"
import { Spin, Card } from "antd"
import ErrorState from "@/components/common/ErrorState"
import { TempLayout } from "@/layouts"
import HeTimesheetDetailView from "./components/HeTimesheetDetailView"
import { useHeTimesheetStore } from "@/stores/he-timesheets/heTimesheetStore"

const HeTimesheetDetail = () => {
  const { recordId } = useParams()
  const fetchHeTimesheetById = useHeTimesheetStore(state => state.fetchHeTimesheetById)
  const currentHeTimesheet = useHeTimesheetStore(state => state.currentHeTimesheet)
  const isLoading = useHeTimesheetStore(state => state.isLoading)
  const error = useHeTimesheetStore(state => state.error)

  useEffect(() => {
    if (recordId) {
      fetchHeTimesheetById(recordId).catch(() => {
        // Error is handled by store state
      })
    }
  }, [recordId, fetchHeTimesheetById])

  return (
    <TempLayout title="HE Timesheet - View Entry" navNavigateUrl="/hets/history">
      <Card>
        {isLoading ? (
          <div style={{ display: "flex", justifyContent: "center", padding: 50 }}>
            <Spin />
          </div>
        ) : error ? (
          <ErrorState
            code={error}
            message={String(error)}
            onAction={() => recordId && void fetchHeTimesheetById(recordId)}
            actionLabel="Retry"
          />
        ) : currentHeTimesheet ? (
          <HeTimesheetDetailView data={currentHeTimesheet} />
        ) : (
          <ErrorState code="404" title="Timesheet Not Found" message="The timesheet you are looking for does not exist." />
        )}
      </Card>
    </TempLayout>
  )
}

export default HeTimesheetDetail
